export default [
  {
    alcoholCheckpoint: true,
    barClosing: true,
    alcoholBan: false,
    curfew: false,
    lockdown: true,
    benefit: 847606658.7,
    cost: 546527730000,
    actualAccident: 6003,
    expectedAccident: 11972,
  },
  {
    alcoholCheckpoint: true,
    barClosing: true,
    alcoholBan: false,
    curfew: false,
    lockdown: false,
    benefit: 526825381.8,
    cost: 272730000,
    actualAccident: 5701,
    expectedAccident: 9410,
  },
  {
    alcoholCheckpoint: true,
    barClosing: false,
    alcoholBan: false,
    curfew: false,
    lockdown: false,
    benefit: 128369311.4,
    cost: 80730000,
    actualAccident: 5553,
    expectedAccident: 6457,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: true,
    curfew: false,
    lockdown: true,
    benefit: 662862771.5,
    cost: 561001000000,
    actualAccident: 6120,
    expectedAccident: 10788,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: true,
    curfew: false,
    lockdown: false,
    benefit: 280878869.3,
    cost: 14746000000,
    actualAccident: 5876,
    expectedAccident: 7854,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: false,
    curfew: false,
    lockdown: true,
    benefit: 632474461,
    cost: 546447000000,
    actualAccident: 6228,
    expectedAccident: 10681,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: false,
    curfew: false,
    lockdown: false,
    benefit: 348613561.3,
    cost: 192000000,
    actualAccident: 5850,
    expectedAccident: 8304,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: true,
    curfew: true,
    lockdown: true,
    benefit: 3270861413,
    cost: 561536000000,
    actualAccident: 5988,
    expectedAccident: 29022,
  },
  {
    alcoholCheckpoint: false,
    barClosing: false,
    alcoholBan: true,
    curfew: false,
    lockdown: false,
    benefit: 125245279.4,
    cost: 14554000000,
    actualAccident: 5903,
    expectedAccident: 6784,
  },
  {
    alcoholCheckpoint: false,
    barClosing: true,
    alcoholBan: false,
    curfew: true,
    lockdown: true,
    benefit: 249922553.1,
    cost: 546982000000,
    actualAccident: 6075,
    expectedAccident: 7834,
  },
].sort(
  (a, b) =>
    b.expectedAccident -
    b.actualAccident -
    (a.expectedAccident - a.actualAccident)
);

export const VIEW_OPTION = {
  costBenefit: 'ผลประโยชน์/ต้นทุน',
  accident: 'จำนวนอุบัติเหตุ',
};
export const COLUMN_OPTION = {
  alcoholCheckpoint: 'ด่านตรวจแอลกอฮอล์',
  barClosing: 'ปิดสถานบันเทิง',
  alcoholBan: 'ห้ามจำหน่ายเครื่องดื่มแอลกอฮอล์',
  curfew: 'เคอร์ฟิว',
  lockdown: 'ล๊อคดาวน์',
};
